var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { ACC_TYPES, CANADA_PROVINCES, COUNTRY_LIST, CustomerEntityTypeOptions, SUFFIX_OPTIONS, TAX_EXEMPT_OPTIONS, TITLE_OPTIONS, USA_STATES, YES_NO_OPTIONS, } from '../../../config/constants';
import { FormFieldType, } from '../../../interfaces/createApplication';
import { emailValidation, phoneNumberValidation, postCodeValidation, } from '../../../utils/customerPortalValidations';
import { API_FIELD } from './api_field_names';
export var CANADA_COUNTRY_CODE = 'CAN';
export var SOLE_PROPRIETORSHIP_ENTITY_CODE = (_b = (_a = CustomerEntityTypeOptions.find(function (entityType) { return entityType.Description === 'Sole Proprietorship'; })) === null || _a === void 0 ? void 0 : _a.Code) !== null && _b !== void 0 ? _b : '';
export var COUNTRY_OPTIONS = COUNTRY_LIST.map(function (country) { return ({
    label: country.country,
    value: country.code,
}); });
export var ENTITY_TYPE_OPTIONS = CustomerEntityTypeOptions.map(function (entityType) { return ({
    label: entityType.Description,
    value: entityType.Code,
}); });
export var SUFFIX_SELECT_OPTIONS = SUFFIX_OPTIONS.map(function (suffix) { return ({
    label: suffix.label,
    value: suffix.value,
}); });
export var TAX_EXEMPT_RADIO_OPTIONS = TAX_EXEMPT_OPTIONS.map(function (option) { return ({
    label: option.label,
    value: option.value,
}); });
export var YES_NO_RADIO_OPTIONS = YES_NO_OPTIONS.map(function (option) { return ({
    label: option.label,
    value: option.value,
}); });
var ACCOUNT_TYPE_OPTIONS = ACC_TYPES.map(function (accountType) { return ({
    label: accountType.label,
    value: accountType.value,
}); });
export var getStateOptions = function (countryCode) {
    var states = countryCode === CANADA_COUNTRY_CODE ? CANADA_PROVINCES : USA_STATES;
    return states.map(function (state) { return ({ label: state.state, value: state.code }); });
};
export var getTitleOptions = function (entityTypeCode) {
    var entityType = CustomerEntityTypeOptions.find(function (option) { return option.Code === String(entityTypeCode !== null && entityTypeCode !== void 0 ? entityTypeCode : ''); });
    if (!entityType) {
        return [];
    }
    var titleGroup = TITLE_OPTIONS.find(function (group) { return group.EntityType === entityType.Description; });
    return titleGroup ? titleGroup.Titles.map(function (title) { return (__assign({}, title)); }) : [];
};
export var getAllTitleOptions = function () {
    var seenValues = new Set();
    var titles = [];
    TITLE_OPTIONS.forEach(function (group) {
        group.Titles.forEach(function (title) {
            if (!seenValues.has(title.value)) {
                seenValues.add(title.value);
                titles.push(__assign({}, title));
            }
        });
    });
    return titles;
};
var groupThousands = function (wholeNumber) {
    return wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var formatAmountInput = function (value) {
    var cleaned = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
    if (!cleaned) {
        return '';
    }
    var _a = cleaned.split('.'), wholePart = _a[0], decimalPart = _a[1];
    var trimmedWhole = wholePart.replace(/^0+(?=\d)/, '').slice(0, 12);
    var grouped = groupThousands(trimmedWhole || '0');
    return decimalPart === undefined
        ? "$".concat(grouped)
        : "$".concat(grouped, ".").concat(decimalPart.slice(0, 2));
};
export var formatCurrencyDisplay = function (amount) {
    var safeAmount = Number.isFinite(amount) ? amount : 0;
    var _a = safeAmount.toFixed(2).split('.'), wholePart = _a[0], decimalPart = _a[1];
    return "$".concat(groupThousands(wholePart), ".").concat(decimalPart);
};
export var formatPhoneInput = function (value) {
    var digitsOnly = value.replace(/\D/g, '').slice(0, 10);
    if (digitsOnly.length <= 3) {
        return digitsOnly;
    }
    if (digitsOnly.length <= 6) {
        return "(".concat(digitsOnly.slice(0, 3), ") ").concat(digitsOnly.slice(3));
    }
    return "(".concat(digitsOnly.slice(0, 3), ") ").concat(digitsOnly.slice(3, 6), "-").concat(digitsOnly.slice(6));
};
export var formatPercentageInput = function (value) {
    var cleaned = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
    var _a = cleaned.split('.'), wholePart = _a[0], decimalPart = _a[1];
    var limitedWhole = wholePart.slice(0, 3);
    return decimalPart === undefined ? limitedWhole : "".concat(limitedWhole, ".").concat(decimalPart.slice(0, 2));
};
export var parseAmount = function (value) {
    var amount = Number(String(value !== null && value !== void 0 ? value : '').replace(/[^\d.]/g, ''));
    return Number.isFinite(amount) ? amount : 0;
};
export var amountValidation = function (value) {
    var amount = Number(String(value !== null && value !== void 0 ? value : '').replace(/[^\d.]/g, ''));
    if (!Number.isFinite(amount) || amount <= 0) {
        return 'Please Enter a Valid Amount';
    }
    return '';
};
export var percentageValidation = function (value) {
    var percentage = Number(String(value !== null && value !== void 0 ? value : ''));
    if (!Number.isFinite(percentage) || percentage <= 0 || percentage > 100) {
        return 'Percent Ownership must be between 1 and 100';
    }
    return '';
};
var EARLIEST_EQUIPMENT_YEAR = 1900;
export var yearValidation = function (value) {
    var year = Number(String(value !== null && value !== void 0 ? value : ''));
    var latestAllowedYear = new Date().getFullYear() + 10;
    if (!Number.isInteger(year) || year < EARLIEST_EQUIPMENT_YEAR || year > latestAllowedYear) {
        return "Year must be between ".concat(EARLIEST_EQUIPMENT_YEAR, " and ").concat(latestAllowedYear);
    }
    return '';
};
export var quantityValidation = function (value) {
    var quantity = Number(String(value !== null && value !== void 0 ? value : ''));
    if (!Number.isInteger(quantity) || quantity <= 0) {
        return 'Quantity must be a whole number greater than zero';
    }
    return '';
};
export var buildAddressFieldName = function (prefix, suffix) {
    return "".concat(prefix).concat(suffix);
};
export var buildAddressFields = function (_a) {
    var prefix = _a.prefix, _b = _a.apiPrefix, apiPrefix = _b === void 0 ? '' : _b, _c = _a.addressLabel, addressLabel = _c === void 0 ? 'Main Address' : _c, _d = _a.stateLabel, stateLabel = _d === void 0 ? 'State/Province Of Incorporation' : _d, _e = _a.includeContact, includeContact = _e === void 0 ? true : _e, emailTooltip = _a.emailTooltip, isDisabled = _a.isDisabled, isVisible = _a.isVisible, _f = _a.dependsOn, dependsOn = _f === void 0 ? [] : _f;
    var fieldName = function (suffix) { return buildAddressFieldName(prefix, suffix); };
    var apiName = function (suffix) { return "".concat(apiPrefix).concat(suffix); };
    var countryFieldName = fieldName('Country');
    var stateFieldName = fieldName('State');
    var addressFields = [
        {
            name: fieldName('Address'),
            apiFieldName: apiName(API_FIELD.Address),
            label: addressLabel,
            type: FormFieldType.AddressAutoComplete,
            isMandatory: true,
            maxLength: 100,
            placeholder: 'Search address or enter manually',
            addressAutofill: {
                address: fieldName('Address'),
                city: fieldName('City'),
                state: stateFieldName,
                country: countryFieldName,
                postalCode: fieldName('PostalCode'),
            },
            isDisabled: isDisabled,
            isVisible: isVisible,
            dependsOn: dependsOn,
        },
        {
            name: countryFieldName,
            apiFieldName: apiName(API_FIELD.Country),
            label: 'Country',
            type: FormFieldType.Select,
            isMandatory: true,
            options: COUNTRY_OPTIONS,
            resetFields: [stateFieldName],
            isDisabled: isDisabled,
            isVisible: isVisible,
            dependsOn: dependsOn,
        },
        {
            name: stateFieldName,
            apiFieldName: apiName(API_FIELD.State),
            label: stateLabel,
            type: FormFieldType.Select,
            isMandatory: true,
            getOptions: function (values) { return getStateOptions(values[countryFieldName]); },
            dependsOn: __spreadArray([countryFieldName], dependsOn, true),
            isDisabled: function (values) { return Boolean(isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled(values)) || !values[countryFieldName]; },
            disabledTooltip: 'Select Country to enable State',
            isVisible: isVisible,
        },
        {
            name: fieldName('City'),
            apiFieldName: apiName(API_FIELD.City),
            label: 'City',
            type: FormFieldType.Text,
            isMandatory: true,
            maxLength: 50,
            isDisabled: isDisabled,
            isVisible: isVisible,
            dependsOn: dependsOn,
        },
        {
            name: fieldName('PostalCode'),
            apiFieldName: apiName(API_FIELD.PostalCode),
            label: 'Zip/Postal Code',
            type: FormFieldType.Text,
            isMandatory: true,
            maxLength: 10,
            validate: function (value) { return postCodeValidation(value); },
            isDisabled: isDisabled,
            isVisible: isVisible,
            dependsOn: dependsOn,
        },
    ];
    if (!includeContact) {
        return addressFields;
    }
    return __spreadArray(__spreadArray([], addressFields, true), [
        {
            name: fieldName('Email'),
            apiFieldName: apiName(API_FIELD.Email),
            label: 'Email',
            type: FormFieldType.Text,
            isMandatory: true,
            maxLength: 100,
            tooltip: emailTooltip,
            validate: function (value) { return emailValidation(value); },
            isDisabled: isDisabled,
            isVisible: isVisible,
            dependsOn: dependsOn,
        },
        {
            name: fieldName('Phone'),
            apiFieldName: apiName(API_FIELD.PhoneNumber),
            label: 'Phone Number',
            type: FormFieldType.Text,
            isMandatory: true,
            maxLength: 14,
            format: formatPhoneInput,
            validate: function (value) { return phoneNumberValidation(value); },
            isDisabled: isDisabled,
            isVisible: isVisible,
            dependsOn: dependsOn,
        },
    ], false);
};
